import LvFanEvent from './LvFanEvent';

const LvFanEventEn = () => {
    return (
        <LvFanEvent
            currentPath="/lv4-en"
            // songGuideTitle="Sing-Along Event Guide Video"
            sloganGuideTitle="Photo Time Slogan Guide"
            eventImage="/fan-event-info-en.png"
        />
    );
};

export default LvFanEventEn;
